import { Link } from '@cloudscape-design/components';
import { Header } from '@cloudscape-design/components';
import { Box } from '@cloudscape-design/components';
import { Popover, SpaceBetween } from '@cloudscape-design/components';
import { StarsIcon } from './StarsIcon';
import { PlaceBasic } from '../common/types';
import { PhoneNumber } from './PhoneNumber';

export type ScorecardHeaderProps = {
  placeLetterGrade: string;
  placePercentile: number;
  place: PlaceBasic;
  borderColor: string;
};

export function ScorecardHeader(props: ScorecardHeaderProps) {
  const { placeLetterGrade, placePercentile, place, borderColor } = props;
  const placeName = place.name;
  const placeAddress = place.address;

  return (
    <SpaceBetween direction="horizontal" size="s">
      <div className="flex flex-col sm:flex-row items-center justify-center gap-8">
        <div>
          <div
            className={`text-center border-box border-4 ${borderColor} pl-4 pr-4 pb-4 pt-2 align-middle w-24`}
          >
            <Popover
              position="bottom"
              size="small"
              triggerType="text"
              header="Letter Grade"
              content={
                <Box variant="span" textAlign="center">
                  Better than {(100 * placePercentile).toFixed(1)}% of similar businesses
                </Box>
              }
            >
              <Box variant="span" textAlign="center" fontWeight="heavy" fontSize="display-l">
                {placeLetterGrade}
              </Box>
            </Popover>
          </div>
        </div>
        <div>
          <SpaceBetween direction="vertical" size="s">
            <Header
              variant="h2"
              description={
                <SpaceBetween direction="vertical" size="xxxs">
                  {placeAddress}
                  <SpaceBetween direction="horizontal" size="xs">
                    {place.rating?.toFixed(1) ?? '?.?'}
                    <StarsIcon stars={place.rating} />
                    <Link href={place.cid_url} target="_blank">
                      {place.total_review_count?.toLocaleString() ?? '?'} Google reviews
                    </Link>
                    {place.phone_number && <PhoneNumber phoneNumber={place.phone_number} />}
                  </SpaceBetween>
                </SpaceBetween>
              }
            >
              {placeName}
            </Header>
          </SpaceBetween>
        </div>
      </div>
    </SpaceBetween>
  );
}
